import React, { useEffect, useState } from 'react'
import { isNullOrUndefined, sleep } from '../utils/generalFunctions'
import * as con from "../Constants"
import { setStoredValue } from '../store/actions'
import { Col, Row, Spin, Table, Typography } from 'antd'
import { CustomGoButton } from '../elements/CustomButtons'
import { RefSetCurrentPage } from '../hooks/NavigationHooks'
import { RefLanguage } from '../hooks/LanguageHooks'
import { historicResultsDB } from '../store/historicResultsDB'

const { Title } = Typography


function HistoricAnnotationResults() {


    // --------------------------

    // Translation
    const i18n = RefLanguage()

    // // Data Hook
    // const historicResultsStack = RefStoredValue(con.ANNOTATION_RESULT_STACK)

    // Table Data
    const [tableData, setTableData] = useState([])

    // Loading
    const [loadingData, setLoadingData] = useState(false)

    // Set the current page
    const setPage = RefSetCurrentPage()


    const loadHistoricResults = async () => {

        setLoadingData(true)

        await sleep(1000) // Simulate loading time

        let historicResultsStack = await historicResultsDB.getAllResults()


        if (isNullOrUndefined(historicResultsStack)) {
            setTableData([])
            setLoadingData(false)

            return
        }

        // Has intermiedate data for selecting and manipulating the original data
        let newTableData = historicResultsStack.map((item) => {

            let newItem = {
                [con.ARC_JOB_ID]: item[con.ARC_METADATA][con.ARC_JOB_ID],
                [con.ARC_TOOL]: item[con.ARC_METADATA][con.ARC_TOOL],
                [con.ARC_ALGORITHM]: item[con.ARC_METADATA][con.ARC_ALGORITHM],
                [con.ARC_RESULTS]: item[con.ARC_RESULTS],


            }

            return newItem
        })

        setTableData(newTableData)
        setLoadingData(false)

    }


    useEffect(() => {
        loadHistoricResults()
    }, [])

    // Defines the columns
    const GENERAL_COLUMNS = [
        {
            title: "Job ID",
            dataIndex: con.ARC_JOB_ID,
            align: 'left',
            width: 120,
            render: (val, record) => !isNullOrUndefined(val) ? val : con.MISSING_VALUE

        },
        {
            title: "Tool",
            dataIndex: con.ARC_TOOL,
            align: 'left',
            width: 120,
            render: (val, record) => !isNullOrUndefined(val) ? val : con.MISSING_VALUE

        },
        {
            title: "Algorithm",
            dataIndex: con.ARC_ALGORITHM,
            align: 'left',
            width: 120,
            render: (val, record) => !isNullOrUndefined(val) ? val : con.MISSING_VALUE

        },
        {
            title: i18n.t("details"),
            align: 'center',
            render: (val, record) => <CustomGoButton onClick={() => {

                console.log("Selected record:", record)
                setStoredValue(con.ANNOTATION_RESULT_DATA, record[con.ARC_RESULTS])
                setPage(con.PAGE_ANNOTATION_RESULTS)

            }} />,
            width: 90,

        }
    ]


    return (
        <div>
            <Row style={{ marginTop: "0.3vh", padding: "0 2vh" }}>
                <Col span={24}>
                    <Title level={3} style={{ marginTop: "0.3vh", paddingTop: 0 }}>{i18n.t("historicResults")}</Title>
                </Col>
            </Row>
            <div>

                <div data-tour="results-table">
                    {
                        loadingData === true

                            ? <Spin size='large' style={{ marginTop: "4vh", marginLeft: "2vh" }} />
                            : <Table
                                dataSource={tableData}
                                columns={GENERAL_COLUMNS}
                                size="small"
                                scroll={{ x: 'max-content' }}
                                pagination={{ pageSize: 15 }}
                                rowKey={con.ARC_QUERY_ID}
                            />
                    }
                </div>
            </div>
        </div>
    )
}

export default HistoricAnnotationResults
